<template>
  <div class="home">
      <login></login>
      
      <div class="home_body">
          <div class="home_body_flex">
              <div class="home_body_flex_top">
                历年真题/笔试内容/题型分值，一键查询！
              </div>
              
              <div class="home_body_flex_picker">
                <div class="home_body_flex_picker_item" @click="subject_show = true" :class="subject_show == true ? 'active' : ''">
                    <i class="iconfont icon-arrow-down"></i>
                    <span>{{subject_name}}</span>
                </div>

                <div class="home_body_flex_picker_item" @click="area_show = true" :class="area_show == true ? 'active' : ''">
                    <i class="iconfont icon-arrow-down"></i>
                    <span>{{area_name}}</span>
                </div>

                <div class="home_body_flex_picker_item" @click="county_show = true" :class="county_show == true ? 'active' : ''">
                    <i class="iconfont icon-arrow-down"></i>
                    <span>{{county_name}}</span>
                </div>
              </div>
             
              <div class="home_body_flex_button" @click='query_now'></div>
          </div>
      </div>
     

      <Bottom></Bottom>
      <van-picker title="选择学科" show-toolbar v-if="subject_show" :columns="subject" @confirm="onfirm_subject" @cancel="onCancel" value-key='name'/>
      <van-picker title="选择地市" show-toolbar v-if="area_show" :columns="area" @confirm="onfirm_area" @cancel="onCancel" value-key='name'/>
      <van-picker title="选择区县" show-toolbar v-if="county_show" :columns="county" @confirm="onfirm_county" @cancel="onCancel" value-key='name'/>

       <!-- 弹出框 -->
      <van-popup v-model="showPopup" round >
        <div class="popup_show">
            <img src="@/assets/img/popup_01.png" />
            <p>新百易温馨提示</p>
            <div class="popup_show_auxiliary">每人仅限查询三个不同学科的真题，选定后不支持修改哦~</div>
            <span class="popup_show_p">您目前已查询过的科目有<span v-for="item in Popup_list" :key='item'>“{{item}}”</span></span>
            <button @click="showPopup = false ">我知道了</button>
        </div>
      </van-popup>
  </div>
</template>

<script>
  import Cookie from 'js-cookie'
  import login from '@/components/login/index.vue'
  import Bottom from '@/components/bottom/index.vue'
  export default {
    name: "home",
    data() {
      return {
        //学科
        subject:[],
        subject_name:'选择学科',
        subject_show: false,
        subject_id:'',
        //地市
        area: [],
        area_name: '选择地市',
        area_show: false,
        area_id: '',
        //区县
        county:[],
        county_name:'选择区县',
        county_show: false,
        county_id: '',
        showPopup: false,
        Popup_list: [],
        data_inof: {}
      };
    },
    props:['api_token', 'agency_id'],
    created() {
      this.subjectList()
      if(localStorage.getItem('subject') != null) {
          this.data_inof = JSON.parse(localStorage.getItem('data_inof'))
      }
      if(sessionStorage.getItem('subject') != null) {
          this.subject_id = sessionStorage.getItem('subject')
          this.subject_name = sessionStorage.getItem('subject_name')
      }

      if(sessionStorage.getItem('county_id') != null) {
          this.county_id = sessionStorage.getItem('county_id')
          this.county_name = sessionStorage.getItem('county_name')
      }

      if(sessionStorage.getItem('area_id') != null) {
          this.area_id = sessionStorage.getItem('area_id')
          this.area_name = sessionStorage.getItem('area_name')
      }
    },
    methods:{
      //查询过的学科
      getSearchSub() {
        this.$axios.get('getSearchSub', {params:{ token: this.api_token, agency_id: this.agency_id}},).then((d)=> {
          if(d.code == 200) {
     
            if(d.data.count >= 2 &&  localStorage.getItem('showPopup') != 'true') {
                this.showPopup = true
                this.Popup_list = d.data.subject
                localStorage.setItem('showPopup',true)
            }
          }
        })
      },
      //点击立即查询
      query_now() {
        console.log(this.api_token)
        sessionStorage.setItem('subject', this.subject_id)
        sessionStorage.setItem('subject_name', this.subject_name)
        sessionStorage.setItem('county_name', this.county_name)
        sessionStorage.setItem('county_id', this.county_id)
        sessionStorage.setItem('area_id', this.area_id)
        sessionStorage.setItem('area_name', this.area_name)
        this.$axios.get('getTextpaperList', {params:{subject:this.subject_id,token:this.api_token, district_and_county:this.county_id, agency_id: this.agency_id, search: 'index'}},).then((d)=> {
          if(d.code == 200) {
            this.$toast(d.message)
            this.$router.push({path:'/results?subject=' + this.subject_id + '&district_and_county=' + this.county_id + '&area_id=' + this.area_id})
            sessionStorage.setItem('subject', "")
            sessionStorage.setItem('subject_name', "选择学科")
            sessionStorage.setItem('county_name', "选择区县")
            sessionStorage.setItem('county_id',"")
            sessionStorage.setItem('area_id', "")
            sessionStorage.setItem('area_name', "选择地市")
          }else if(d.code == 202) {
            var localhost = window.location.href;
            this.$toast('正在跳转登陆')
            setTimeout(function(){
              var host = window.location.href.replace(/#/g,"vue")
              window.location.href = window.location.origin + '/m/login?turn_jump_url=' + host;
            },400)
          }else {
            this.$toast(d.message)
          }
        })
      },
      //获取学科内容
      subjectList(){
        this.$axios.get('subjectList', {}).then((d)=> {
          if(d.code == 200) {
            this.subject = d.data
          }else {
            this.$toast(d.message)
          }
        }).catch((err) => {
          //  this.$toast(err)
        });
      },
       //获取区县内容
      areaList(){
        this.$axios.get('areaList', {params:{subject:this.subject_id}},).then((d)=> {
          if(d.code == 200) {
            this.area = d.data
          }else {
            this.$toast(d.message)
          }
        }).catch((err) => {
          //  this.$toast(err)
        });
      },
      //选择学科
      onfirm_subject(value, index) {
        this.subject_name = value.name
        this.subject_id = value.id
        this.getSearchSub()
        this.show_picer()
        this.areaList()
        this.empty()
      },
      //选择地市
      onfirm_area(value, index) {
        this.area_name = value.name
        this.area_id = value.id
        this.county = value.county
        this.show_picer()
      },
       //选择区县
      onfirm_county(value, index) {
        this.county_name = value.name
        this.county_id = value.id
        this.show_picer()
      },
      //取消
      onCancel() {
        this.show_picer()
      },
      //隐藏选择器
      show_picer() {
        this.subject_show = false
        this.area_show = false
        this.county_show = false
      },
      //清空之前选择的内容
      empty() {
        this.area_id = ''
        this.area_name = '选择地市'
        this.county_id = ''
        this.county_name = '选择区县'
      }
    },
    mounted() {
      
    },
    components: {
      login,Bottom
    },
  };
</script>

<style lang="less" scoped>
  /deep/ .van-ellipsis {
    height: 1rem;
    font-size: .32rem;
    line-height: 1rem;
  }

  /deep/ .van-picker__toolbar > button {
    font-size: .3rem;
  }

  /deep/ .van-picker__toolbar {
    height: .9rem;
  }

  .van-picker {
    position: fixed;
    width: 100%;
    bottom: 0;
  }

  .home_body {
    width: 7.5rem;
    height: 90.5vh;
    background: url('../../assets/img/index_01.png') top center no-repeat;
    background-size: 7.5rem 92vh;
    .home_body_flex {
      width: 6.88rem;
      height: 6.72rem;
      background: #FFFFFF;
      box-shadow: 0rem 0rem 4px rgba(0, 0, 0, 0.1);
      border-radius: 0.19rem;
      position: relative;
      top: 4.76rem;
      left: 0;
      right: 0;
      margin: auto;
      padding-top: .56rem;
      .home_body_flex_top {
        height: 0.3rem;
        font-size: 0.3rem;
        font-weight: 500;
        color: #3C4650;
        line-height: 0.46rem;
        text-align: center;
        margin: 0 auto;
      }

      .home_body_flex_button {
        width: 6.3rem;
        height: 1.29rem;
        background: url('../../assets/img/index_02.png')  center center no-repeat;
        background-size: 6.3rem 1.29rem;
        margin: 0 auto;
        margin-top: .73rem;
      }
    }

    .home_body_flex_picker {
      width: 6.1rem;
      margin: 0 auto;
      margin-top: .6rem;
      .home_body_flex_picker_item {
        display: flex;
        width: 5.89rem;
        height: 0.8rem;
        background: #FFFFFF;
        border: 1px solid #EAEAEA;
        border-radius: 0.4rem;
        margin: 0  auto;
        align-items: center;
        position: relative;
        margin-top: .29rem;
        > span {
          font-size: 0.28rem;
          font-weight: 500;
          color: #333333;
          line-height: 0.8rem;
          margin-left: .41rem;
        }

        > i {
          position: absolute;
          right: .41rem;
          font-size: .4rem;
          color: #92979B;
        }
      }

      .active {
        border: 1px solid #FF774E;
        > span {
          color: #FF774E;
        }

        > i {
          color: #FF774E;
        }
      }
    }
  }

  .popup_show {
    width: 6.88rem;
    margin: 0 auto;
    padding: .48rem;
    padding-top: .57rem;
    > img {
      height: 2.84rem;
      display: block;
      margin: 0 auto;
    }

    > p {
      margin: 0;
      font-size: 0.38rem;
      font-family: PingFang SC;
      font-weight: bold;
      color: #000000;
      line-height: 0.5rem;
      margin-top: .69rem;
      text-align: center;
    }

    > .popup_show_auxiliary {
      font-size: 0.3rem;
      font-weight: 500;
      color: #6F6F6F;
      margin-top: .38rem;
      line-height: .4rem;
    }

    .popup_show_p {
      font-size: 0.3rem;
      font-family: PingFang SC;
      font-weight: 500;
      display: block;
      margin-top: .39rem;
      color: #333333;
      > span {
        color: #FF794F;
      }
    }

    > button {
      width: 2.46rem;
      height: 0.8rem;
      border: none;
      background: linear-gradient(90deg, #FD9366, #FF734A);
      box-shadow: 0rem 0rem 0rem 1px rgba(255, 145, 96, 0.74);
      border-radius: 0.4rem;
      font-size: 0.36rem;
      font-weight: 500;
      color: #FFFFFF;
      line-height: 0.8rem;
      margin: 0 auto;
      display: block;
      margin-top: .62rem;
      text-shadow: 0rem 0rem 1px rgba(255, 59, 0, 0.27);
    }
  }
</style>
